exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrolling-wrapper{overflow-x:scroll;overflow-y:hidden;white-space:nowrap}.card-block{min-height:220px}.block-flat,.block-wizard{margin-bottom:40px;padding:20px;background:#fff;border-radius:3px;position:relative;-webkit-border-radius:3px;border-left:1px solid #efefef;border-right:1px solid #efefef;border-bottom:1px solid #e2e2e2;box-shadow:0 1px 0 0 rgba(0,0,0,.04);transition:padding .5s;-moz-transition:padding .5s;-webkit-transition:padding .5s}.muda-filtro h4{margin:0;padding:15px;text-align:center;color:#fff;background:#3c94e0;cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:Open Sans,sans-serif;font-weight:300}.h4,h4{font-size:1.275rem}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ae5d8ae","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/geral/main.vue
// module id = 558
// module chunks = 0